module.exports = __webpack_public_path__ + "img/waistband buttons quantity.3c086689.png";